import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SpecraHubGrid } from '@mono/ui-components/captains';
import { SpecraBadge, SpecraText } from '@mono/ui-components/ensigns';
import { SpecraSectionHeader } from '@mono/ui-components/lieutenants';
import { Testids } from '@mono/ui-selectors';
import { renderRouterLink } from '../../../../lib/renderRouterLink';
import { planeVariant } from '../../badgeVariants';
import { registryHref } from '../../registryHref';
const PLANE_LABEL = {
    GROWTH: 'Growth',
    PROPOSAL: 'Proposal',
    DELIVERY: 'Delivery'
};
/** One card per plane the viewer can see; none when nothing is visible. */ export function WhereTheyAppear({ cards }) {
    return /*#__PURE__*/ _jsxs("section", {
        className: "space-y-3",
        children: [
            /*#__PURE__*/ _jsx(SpecraSectionHeader, {
                variant: "group",
                title: "Where they appear · same row everywhere"
            }),
            cards.length === 0 ? /*#__PURE__*/ _jsx(SpecraText, {
                as: "p",
                size: "body-ui",
                tone: "muted",
                children: "Nothing you can see links to this person yet."
            }) : /*#__PURE__*/ _jsx(SpecraHubGrid, {
                columns: 3,
                renderLink: renderRouterLink,
                getItemTestId: ()=>Testids.registryPerson.appearCard,
                items: cards.map((c)=>({
                        id: c.plane,
                        title: c.title,
                        description: c.summary || undefined,
                        eyebrow: /*#__PURE__*/ _jsx(SpecraBadge, {
                            variant: planeVariant(c.plane),
                            children: PLANE_LABEL[c.plane]
                        }),
                        href: registryHref(c.primary) ?? undefined
                    }))
            })
        ]
    });
}
